import { CalculatorIcon, MoneyIcon, PersonIcon, ShapesIcon, WarehouseIcon } from '@phosphor-icons/react'

export const integrationsCategories = [
  {
    type: '3pl',
    name: '3PL',
    icon: <WarehouseIcon size={20} weight="light" />,
  },
  {
    type: 'crm',
    name: 'CRM',
    icon: <PersonIcon size={20} weight="light" />,
  },
  {
    type: 'erp',
    name: 'ERP',
    icon: <CalculatorIcon size={20} weight="light" />,
  },
  {
    type: 'payments',
    name: 'Pagos',
    icon: <MoneyIcon size={20} weight="light" />,
  },
  {
    type: 'miscellany',
    name: 'Miscellaneous',
    icon: <ShapesIcon size={20} weight="light" />,
  },
]

export const integrationStatuses = {
  notInstalled: 'not_installed',
  disabled: 'disabled',
  pending: 'pending',
  rejected: 'rejected',
  installed: 'installed',
  failed: 'failed',
}
